import * as types from "../../constants";

import * as actions from "../actions-declarations/a11yStandard";
import { ActionsOf } from "../utils";

export type A11yStandardActions = typeof actions;

export default function reducer(
    state = { a11yStandard: [] as any[], loading: true },
    actions: ActionsOf<A11yStandardActions>): typeof state {
    switch (actions.type) {
        case "FETCH_A11YSTANDARD_LOADING":
            return {
                ...state,
                loading: true
            };
        case "FETCH_A11YSTANDARD":
            return {
                ...state,
                a11yStandard: actions.payload,
                loading: false
            };
        default:
            return state;
    }
}